import styles from './GlobalFooter.module.scss';

/**
 * GlobalFooter 컴포넌트
 * - 애플리케이션 하단 푸터 바
 * - 저작권 정보 표시
 */
export default function GlobalFooter() {
  return (
    <footer className={styles.footer}>
      <span className={styles.copyright}>
        Copyright &#9426; 2025 PONYLINK. All rights reserved.
      </span>
    </footer>
  );
}
